import * as Sentry from '@sentry/react'
import { type FC, type ReactNode } from 'react'
import { HelmetProvider } from 'react-helmet-async'

import { AntdProvider } from '@/libs/antd'
import { QueryClientProvider } from '@/libs/react-query'
import { Toaster } from '@/libs/toast'

type AppProviderProps = {
  children: ReactNode
}

export const AppProvider: FC<AppProviderProps> = ({ children }) => {
  // 全環境でSentry ErrorBoundaryを使用（ローカルでの大量送信防止のため、デバッグ有効時のみ動作）
  const isDebug = import.meta.env.VITE_SENTRY_DEBUG === '1'
  const isLocalhost = ['localhost', '127.0.0.1', '::1'].includes(
    window.location.hostname
  )
  const shouldEnableBoundary = isLocalhost ? isDebug : true
  const content = shouldEnableBoundary ? (
    <Sentry.ErrorBoundary fallback={<></>} showDialog={false}>
      {children}
    </Sentry.ErrorBoundary>
  ) : (
    <>{children}</>
  )

  return (
    <HelmetProvider>
      <QueryClientProvider>
        <AntdProvider>{content}</AntdProvider>
        <Toaster />
      </QueryClientProvider>
    </HelmetProvider>
  )
}
